export default {
      id: "ic_info_main_green-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic_info_main_green-usage",
      toString: function () {
        return this.url;
      }
    }